import { findDOMNode } from 'react-dom';
import { isComponent, isHTMLElement } from "../helpers/reflect";
import { CELL_STYLE_CONFIG, STATUS_CELL } from './MatrixCell';
import { DAYS, DISPLAY_EU_HOURS, DISPLAY_CONFIG_VARIANTS } from './Matrix';
import { BACKUP_MATRIX_FORMAT, CURSOR_EVENT } from "./types";
var SELECT_CELLS_OPTION;
(function (SELECT_CELLS_OPTION) {
    SELECT_CELLS_OPTION["fromMainCell"] = "fromMainCell";
    SELECT_CELLS_OPTION["fromDayCaptionToOtherHour"] = "fromDayCaptionToOtherHour";
    SELECT_CELLS_OPTION["fromHourCaptionToOtherDay"] = "fromHourCaptionToOtherDay";
})(SELECT_CELLS_OPTION || (SELECT_CELLS_OPTION = {}));
var getKeyByValue = function (object, value) {
    var resultSearchKey = Object.keys(object).find(function (key) { return object[key] === value; });
    if (resultSearchKey) {
        return parseInt(resultSearchKey, 10);
    }
    return undefined;
};
// Editing function of a single considered cell in the array currSelectedCells
var editSelectedCells = function (partTmpEditedStateCopy, indexDay, indexHour, isProcessSelect, isFirstCall) {
    if (isFirstCall === void 0) { isFirstCall = true; }
    var selectedCellsCopy = partTmpEditedStateCopy.selectedCells, isSelectModeCopy = partTmpEditedStateCopy.isSelectMode, startPosition = partTmpEditedStateCopy.startPosition, isActiveCopy = partTmpEditedStateCopy.isActive;
    var resultSelectedCells;
    if (!isFirstCall && isProcessSelect) {
        resultSelectedCells = partTmpEditedStateCopy['tmpResultSelectedCells'];
    }
    else {
        resultSelectedCells = isProcessSelect ? {} : selectedCellsCopy;
    }
    if (isSelectModeCopy || isProcessSelect) {
        // select mode is Permitted or select is processing
        if (indexHour === -1) {
            if (indexDay >= 0 && indexDay <= DAYS.length - 1) {
                // TODO: need to del indexHour = -1
                resultSelectedCells[indexDay] =
                    isActiveCopy && startPosition.indexDay === undefined
                        ? [-1]
                        : DISPLAY_EU_HOURS.slice(0, -1);
            }
        }
        else if (isActiveCopy && startPosition.indexHour === undefined) {
            if (indexDay === 1) {
                // TODO: need to del indexDay = -1
                resultSelectedCells[-1] = [indexHour];
            }
        }
        else if (!Object.prototype.hasOwnProperty.call(resultSelectedCells, indexDay)) {
            if (isProcessSelect) {
                resultSelectedCells[indexDay] = [indexHour];
            }
            else if (indexDay >= 0) {
                resultSelectedCells[indexDay] = [indexHour];
            }
        }
        else if (!resultSelectedCells[indexDay].includes(indexHour)) {
            if (isProcessSelect) {
                resultSelectedCells[indexDay].push(indexHour);
            }
            else if (indexDay >= 0) {
                resultSelectedCells[indexDay].push(indexHour);
            }
        }
    }
    else if (!isSelectModeCopy &&
        indexHour === -1 &&
        Object.prototype.hasOwnProperty.call(resultSelectedCells, indexDay)) {
        // else select mode is Denied and selected Day
        delete resultSelectedCells[indexDay];
    }
    else if (!isSelectModeCopy &&
        indexHour !== -1 &&
        Object.prototype.hasOwnProperty.call(resultSelectedCells, indexDay) &&
        resultSelectedCells[indexDay].includes(indexHour)) {
        // else select mode is Denied and selected area on matrix cells
        var key = getKeyByValue(resultSelectedCells[indexDay], indexHour);
        if (key !== undefined && key >= 0) {
            resultSelectedCells[indexDay].splice(key, 1);
            if (resultSelectedCells[indexDay].length === 0) {
                delete resultSelectedCells[indexDay];
            }
        }
    }
    return resultSelectedCells;
};
var getDataOfSelectElementByMode = function (mode, format, isProcessSelect, tmpEditedStateCopy) {
    var selectedCells = tmpEditedStateCopy.selectedCells, isSelectMode = tmpEditedStateCopy.isSelectMode, isActive = tmpEditedStateCopy.isActive, _a = tmpEditedStateCopy.startPosition, startPositionIndexHour = _a.indexHour, startPositionIndexDay = _a.indexDay, _b = tmpEditedStateCopy.endPosition, endPositionIndexHour = _b.indexHour, endPositionIndexDay = _b.indexDay, _c = tmpEditedStateCopy.hoverPosition, hoverPositionIndexHour = _c.indexHour, hoverPositionIndexDay = _c.indexDay, tmpActiveFirstSelectedCell = tmpEditedStateCopy.tmpActiveFirstSelectedCell;
    var resultSelectedCells = {};
    var startIndexHourTmp;
    var endIndexHourTmp;
    var startIndexDayTmp;
    var endIndexDayTmp;
    var countCalledEditSelectedCells = 0;
    var newTmpActiveFirstSelectedCell;
    if (mode === SELECT_CELLS_OPTION.fromMainCell) {
        newTmpActiveFirstSelectedCell = tmpActiveFirstSelectedCell;
        if (isProcessSelect &&
            startPositionIndexHour === hoverPositionIndexHour &&
            startPositionIndexDay === hoverPositionIndexDay) {
            var mainCellStatusTmp = isSelectMode ? STATUS_CELL.SELECTED : STATUS_CELL.UNSELECTED;
            newTmpActiveFirstSelectedCell = {
                indexHour: startPositionIndexHour,
                indexDay: startPositionIndexDay,
                status: mainCellStatusTmp
            };
        }
    }
    // sort indexHour positions
    if (startPositionIndexHour >= endPositionIndexHour) {
        startIndexHourTmp =
            mode === SELECT_CELLS_OPTION.fromDayCaptionToOtherHour ? 0 : endPositionIndexHour;
        endIndexHourTmp = startPositionIndexHour;
    }
    else {
        startIndexHourTmp =
            mode === SELECT_CELLS_OPTION.fromDayCaptionToOtherHour ? 0 : startPositionIndexHour;
        endIndexHourTmp = endPositionIndexHour;
    }
    // sort indexDay positions
    if (format === BACKUP_MATRIX_FORMAT.us &&
        startPositionIndexDay === DISPLAY_CONFIG_VARIANTS[format].dayStartIndex &&
        endPositionIndexDay !== DISPLAY_CONFIG_VARIANTS[format].dayStartIndex &&
        ((mode === SELECT_CELLS_OPTION.fromHourCaptionToOtherDay && endPositionIndexDay === -1) ||
            endPositionIndexDay >= 0)) {
        startIndexDayTmp = 0;
        endIndexDayTmp = endPositionIndexDay;
    }
    else if (format === BACKUP_MATRIX_FORMAT.us &&
        endPositionIndexDay === DISPLAY_CONFIG_VARIANTS[format].dayStartIndex &&
        startPositionIndexDay !== DISPLAY_CONFIG_VARIANTS[format].dayStartIndex &&
        ((mode === SELECT_CELLS_OPTION.fromHourCaptionToOtherDay && startPositionIndexDay === -1) ||
            startPositionIndexDay >= 0)) {
        startIndexDayTmp = 0;
        endIndexDayTmp = startPositionIndexDay;
    }
    else if (startPositionIndexDay >= endPositionIndexDay) {
        startIndexDayTmp =
            mode === SELECT_CELLS_OPTION.fromHourCaptionToOtherDay ? 0 : endPositionIndexDay;
        endIndexDayTmp = startPositionIndexDay;
    }
    else {
        startIndexDayTmp =
            mode === SELECT_CELLS_OPTION.fromHourCaptionToOtherDay ? 0 : startPositionIndexDay;
        endIndexDayTmp = endPositionIndexDay;
    }
    if (mode !== SELECT_CELLS_OPTION.fromMainCell || !isProcessSelect) {
        if (mode !== SELECT_CELLS_OPTION.fromDayCaptionToOtherHour) {
            // fix selection of cells when the cursor is located outside the matrix
            if (startIndexHourTmp === -1) {
                startIndexHourTmp = 0;
            }
        }
        if (mode !== SELECT_CELLS_OPTION.fromHourCaptionToOtherDay) {
            if (format === BACKUP_MATRIX_FORMAT.us &&
                startIndexDayTmp === -1 &&
                endIndexDayTmp === DISPLAY_CONFIG_VARIANTS[format].dayStartIndex) {
                startIndexDayTmp = DISPLAY_CONFIG_VARIANTS[format].dayStartIndex;
            }
        }
    }
    for (var indexDay = startIndexDayTmp; indexDay <= endIndexDayTmp; indexDay += 1) {
        if (mode === SELECT_CELLS_OPTION.fromHourCaptionToOtherDay &&
            format === BACKUP_MATRIX_FORMAT.us &&
            indexDay === DISPLAY_CONFIG_VARIANTS[format].dayStartIndex) {
            break;
        }
        if (mode === SELECT_CELLS_OPTION.fromMainCell ||
            (mode === SELECT_CELLS_OPTION.fromDayCaptionToOtherHour && indexDay !== -1) ||
            (mode === SELECT_CELLS_OPTION.fromHourCaptionToOtherDay &&
                (format !== BACKUP_MATRIX_FORMAT.us ||
                    (format === BACKUP_MATRIX_FORMAT.us &&
                        indexDay !== DISPLAY_CONFIG_VARIANTS[format].dayStartIndex)))) {
            for (var indexHour = startIndexHourTmp; indexHour <= endIndexHourTmp; indexHour += 1) {
                countCalledEditSelectedCells += 1;
                resultSelectedCells = editSelectedCells({
                    selectedCells: selectedCells,
                    isSelectMode: isSelectMode,
                    startPosition: {
                        indexHour: startPositionIndexHour,
                        indexDay: startPositionIndexDay
                    },
                    isActive: isActive,
                    tmpResultSelectedCells: resultSelectedCells
                }, indexDay, indexHour, isProcessSelect, countCalledEditSelectedCells === 1);
            }
        }
    }
    if (format === BACKUP_MATRIX_FORMAT.us &&
        (mode === SELECT_CELLS_OPTION.fromHourCaptionToOtherDay ||
            // mode !== SELECT_CELLS_OPTION.fromHourCaptionToOtherDay &&
            startPositionIndexDay === DISPLAY_CONFIG_VARIANTS[format].dayStartIndex ||
            startPositionIndexDay === -1 ||
            endPositionIndexDay === DISPLAY_CONFIG_VARIANTS[format].dayStartIndex ||
            endPositionIndexDay === -1) &&
        (mode !== SELECT_CELLS_OPTION.fromDayCaptionToOtherHour ||
            startPositionIndexDay !== endPositionIndexDay)) {
        for (var indexHour = startIndexHourTmp; indexHour <= endIndexHourTmp; indexHour += 1) {
            countCalledEditSelectedCells += 1;
            resultSelectedCells = editSelectedCells({
                selectedCells: selectedCells,
                isSelectMode: isSelectMode,
                startPosition: {
                    indexHour: startPositionIndexHour,
                    indexDay: startPositionIndexDay
                },
                isActive: isActive,
                tmpResultSelectedCells: resultSelectedCells
            }, DISPLAY_CONFIG_VARIANTS[format].dayStartIndex, indexHour, isProcessSelect, countCalledEditSelectedCells === 1);
        }
    }
    switch (mode) {
        case SELECT_CELLS_OPTION.fromDayCaptionToOtherHour:
            return {
                selectedCells: resultSelectedCells,
                isSelectedDay: false
            };
        case SELECT_CELLS_OPTION.fromMainCell:
            return {
                selectedCells: resultSelectedCells,
                tmpActiveFirstSelectedCell: newTmpActiveFirstSelectedCell
            };
        case SELECT_CELLS_OPTION.fromHourCaptionToOtherDay:
            return {
                selectedCells: resultSelectedCells,
                isSelectedHour: false
            };
        default:
            return {};
    }
};
export var getDataOfSelectFromDayCaptionToOtherHour = function (format, isProcessSelect, tmpEditedStateCopy) {
    return getDataOfSelectElementByMode(SELECT_CELLS_OPTION.fromDayCaptionToOtherHour, format, isProcessSelect, tmpEditedStateCopy);
};
export var getDataOfSelectDayCaption = function (isProcessSelect, tmpEditedStateCopy) {
    var selectedCells = tmpEditedStateCopy.selectedCells, isSelectMode = tmpEditedStateCopy.isSelectMode, isActive = tmpEditedStateCopy.isActive, _a = tmpEditedStateCopy.startPosition, startPositionIndexHour = _a.indexHour, startPositionIndexDay = _a.indexDay;
    var captionCellStatusTmp;
    if (!isProcessSelect) {
        captionCellStatusTmp = isSelectMode ? STATUS_CELL.SELECT_HOVER : STATUS_CELL.UNSELECT_HOVER;
    }
    else {
        captionCellStatusTmp = isSelectMode ? STATUS_CELL.SELECTED : STATUS_CELL.UNSELECTED;
    }
    return {
        selectedCells: editSelectedCells({
            selectedCells: selectedCells,
            isSelectMode: isSelectMode,
            startPosition: {
                indexHour: startPositionIndexHour,
                indexDay: startPositionIndexDay
            },
            isActive: isActive
        }, startPositionIndexDay, -1, isProcessSelect),
        isSelectedDay: true,
        tmpActiveFirstSelectedCell: {
            indexHour: -1,
            indexDay: startPositionIndexDay,
            status: captionCellStatusTmp
        }
    };
};
export var getDataOfSelectFromHourCaptionToOtherDay = function (format, isProcessSelect, tmpEditedStateCopy) {
    return getDataOfSelectElementByMode(SELECT_CELLS_OPTION.fromHourCaptionToOtherDay, format, isProcessSelect, tmpEditedStateCopy);
};
export var getDataOfSelectHourCaption = function (isProcessSelect, tmpEditedStateCopy) {
    var selectedCells = tmpEditedStateCopy.selectedCells, isSelectMode = tmpEditedStateCopy.isSelectMode, isActive = tmpEditedStateCopy.isActive, _a = tmpEditedStateCopy.startPosition, startPositionIndexHour = _a.indexHour, startPositionIndexDay = _a.indexDay;
    var resultSelectedCells = {};
    var captionCellStatusTmp;
    if (!isProcessSelect) {
        captionCellStatusTmp = isSelectMode ? STATUS_CELL.SELECT_HOVER : STATUS_CELL.UNSELECT_HOVER;
    }
    else {
        captionCellStatusTmp = isSelectMode ? STATUS_CELL.SELECTED : STATUS_CELL.UNSELECTED;
    }
    DAYS.forEach(function (displayDay, indexDay) {
        resultSelectedCells = editSelectedCells({
            selectedCells: selectedCells,
            isSelectMode: isSelectMode,
            startPosition: {
                indexHour: startPositionIndexHour,
                indexDay: startPositionIndexDay
            },
            isActive: isActive,
            tmpResultSelectedCells: resultSelectedCells
        }, indexDay, startPositionIndexHour, isProcessSelect, indexDay === 0);
    });
    return {
        selectedCells: resultSelectedCells,
        isSelectedHour: true,
        tmpActiveFirstSelectedCell: {
            indexHour: startPositionIndexHour,
            indexDay: -1,
            status: captionCellStatusTmp
        }
    };
};
export var getDataOfSelectFromMainCell = function (format, isProcessSelect, tmpEditedStateCopy) {
    return getDataOfSelectElementByMode(SELECT_CELLS_OPTION.fromMainCell, format, isProcessSelect, tmpEditedStateCopy);
};
export var getDataOfHoverDayCaption = function (isProcessSelect, tmpEditedStateCopy) {
    var selectedCells = tmpEditedStateCopy.selectedCells, isSelectMode = tmpEditedStateCopy.isSelectMode, isActive = tmpEditedStateCopy.isActive, _a = tmpEditedStateCopy.startPosition, startPositionIndexHour = _a.indexHour, startPositionIndexDay = _a.indexDay, hoverPositionIndexDay = tmpEditedStateCopy.hoverPosition.indexDay;
    return {
        selectedCells: editSelectedCells({
            selectedCells: selectedCells,
            isSelectMode: isSelectMode,
            startPosition: {
                indexHour: startPositionIndexHour,
                indexDay: startPositionIndexDay
            },
            isActive: isActive
        }, hoverPositionIndexDay, -1, isProcessSelect)
    };
};
export var getDataOfHoverHourCaption = function (event, format, isProcessSelect, tmpEditedStateCopy) {
    var selectedCells = tmpEditedStateCopy.selectedCells, isSelectMode = tmpEditedStateCopy.isSelectMode, isActive = tmpEditedStateCopy.isActive, startPosition = tmpEditedStateCopy.startPosition, hoverPositionIndexHour = tmpEditedStateCopy.hoverPosition.indexHour;
    var resultSelectedCells = {};
    if ((event === CURSOR_EVENT.onMouseMove &&
        hoverPositionIndexHour >= -1 &&
        hoverPositionIndexHour <= 23) ||
        event === CURSOR_EVENT.null) {
        DAYS.forEach(function (displayDay, indexDay) {
            resultSelectedCells = editSelectedCells({
                selectedCells: selectedCells,
                isSelectMode: isSelectMode,
                startPosition: startPosition,
                isActive: isActive,
                tmpResultSelectedCells: resultSelectedCells
            }, indexDay, hoverPositionIndexHour, isProcessSelect, indexDay === 0);
        });
    }
    return {
        selectedCells: resultSelectedCells
    };
};
export var getDataOfHoverMainCell = function (isProcessSelect, tmpEditedStateCopy) {
    var selectedCells = tmpEditedStateCopy.selectedCells, isSelectMode = tmpEditedStateCopy.isSelectMode, isActive = tmpEditedStateCopy.isActive, startPosition = tmpEditedStateCopy.startPosition, _a = tmpEditedStateCopy.hoverPosition, hoverPositionIndexHour = _a.indexHour, hoverPositionIndexDay = _a.indexDay;
    return {
        selectedCells: editSelectedCells({
            selectedCells: selectedCells,
            isSelectMode: isSelectMode,
            startPosition: startPosition,
            isActive: isActive
        }, hoverPositionIndexDay, hoverPositionIndexHour, isProcessSelect)
    };
};
var getDOMNode = function (ref) {
    return isHTMLElement(ref.current)
        ? ref.current
        : // eslint-disable-next-line react/no-find-dom-node
            findDOMNode(isComponent(ref.current) ? ref.current : null);
};
var getMatrixCSSProps = function (ref) {
    var domNode = getDOMNode(ref);
    var rect = domNode.getBoundingClientRect();
    var SUM_MARGIN_CELL = 2 * CELL_STYLE_CONFIG.main.margin;
    var MATRIX_MAIN_MARGIN_TOP = CELL_STYLE_CONFIG.hourDescription.marginTop +
        CELL_STYLE_CONFIG.hourDescription.height +
        CELL_STYLE_CONFIG.main.height +
        SUM_MARGIN_CELL;
    var WIDTH_BOX_CELL = CELL_STYLE_CONFIG.main.margin + CELL_STYLE_CONFIG.main.width;
    var HEIGHT_BOX_CELL = CELL_STYLE_CONFIG.main.margin + CELL_STYLE_CONFIG.main.height;
    var WIDTH_MAIN_COL_MATRIX = (DISPLAY_EU_HOURS.length - 1) *
        (CELL_STYLE_CONFIG.main.width + CELL_STYLE_CONFIG.main.margin) +
        CELL_STYLE_CONFIG.hourCaption.marginLeft;
    var CAPTION_DAY_WIDTH = rect.width - WIDTH_MAIN_COL_MATRIX;
    var MATRIX_MAIN_LEFT = rect.left + CAPTION_DAY_WIDTH;
    var MATRIX_MAIN_TOP = rect.top + MATRIX_MAIN_MARGIN_TOP;
    var MATRIX_MAIN_RIGHT = MATRIX_MAIN_LEFT + (DISPLAY_EU_HOURS.length - 1) * WIDTH_BOX_CELL;
    var MATRIX_MAIN_BOTTOM = MATRIX_MAIN_TOP + (DAYS.length * HEIGHT_BOX_CELL - CELL_STYLE_CONFIG.main.margin);
    return {
        left: rect.left,
        top: rect.top,
        mainLeft: MATRIX_MAIN_LEFT,
        mainTop: MATRIX_MAIN_TOP,
        mainRight: MATRIX_MAIN_RIGHT,
        mainBottom: MATRIX_MAIN_BOTTOM,
        cellWidth: WIDTH_BOX_CELL,
        cellHeight: HEIGHT_BOX_CELL
    };
};
var getIndexHourOfCoordinateCursor = function (isEmptyOldStartPosition, cursorX, partMatrixInfo) {
    var widthCellWithPadding = partMatrixInfo.cellWidth, matrixLeft = partMatrixInfo.left, matrixRight = partMatrixInfo.mainRight, dayCaptionRight = partMatrixInfo.mainLeft;
    var resultIndexHour = null;
    if (cursorX < matrixLeft) {
        resultIndexHour = isEmptyOldStartPosition ? null : -1;
    }
    else if (cursorX > matrixRight) {
        resultIndexHour = isEmptyOldStartPosition ? null : DISPLAY_EU_HOURS.length - 2;
    }
    else if (cursorX >= matrixLeft && cursorX < dayCaptionRight) {
        resultIndexHour = -1;
    }
    else {
        var minIndexHourHoverCell = Math.floor((cursorX - dayCaptionRight) / widthCellWithPadding);
        var minX = dayCaptionRight + minIndexHourHoverCell * widthCellWithPadding;
        var maxX = minX + CELL_STYLE_CONFIG.main.width;
        if (cursorX >= minX && cursorX <= maxX) {
            resultIndexHour = minIndexHourHoverCell;
        }
    }
    return resultIndexHour;
};
var getIndexDayOfCoordinateCursor = function (format, isEmptyOldStartPosition, cursorY, partMatrixInfo) {
    var heightCellWithPadding = partMatrixInfo.cellHeight, matrixTop = partMatrixInfo.top, matrixBottom = partMatrixInfo.mainBottom, hourCaptionBottom = partMatrixInfo.mainTop;
    var resultIndexDay = null;
    if (cursorY < matrixTop) {
        resultIndexDay = isEmptyOldStartPosition ? null : -1;
    }
    else if (cursorY > matrixBottom) {
        if (isEmptyOldStartPosition) {
            resultIndexDay = null;
        }
        else {
            resultIndexDay = format === BACKUP_MATRIX_FORMAT.us ? 5 : 6;
        }
    }
    else if (cursorY >= matrixTop && cursorY < hourCaptionBottom) {
        resultIndexDay = -1;
    }
    else {
        var minIndexDayHoverCell = Math.floor((cursorY - hourCaptionBottom) / heightCellWithPadding);
        var minY = hourCaptionBottom + minIndexDayHoverCell * heightCellWithPadding;
        var maxY = minY + CELL_STYLE_CONFIG.main.height;
        if (cursorY >= minY && cursorY <= maxY) {
            if (format === BACKUP_MATRIX_FORMAT.us) {
                resultIndexDay = minIndexDayHoverCell === 0 ? 6 : minIndexDayHoverCell - 1;
            }
            else {
                resultIndexDay = minIndexDayHoverCell;
            }
        }
    }
    return resultIndexDay;
};
export var getCellMainDataOfCursor = function (ref, format, oldStartPosition, coordinateCursor) {
    var cursorX = coordinateCursor.cursorX, cursorY = coordinateCursor.cursorY;
    var isEmptyOldStartPosition = Object.entries(oldStartPosition).length === 0 && oldStartPosition.constructor === Object;
    var matrixInfo = getMatrixCSSProps(ref);
    var newIndexHour = getIndexHourOfCoordinateCursor(isEmptyOldStartPosition, cursorX, {
        cellWidth: matrixInfo.cellWidth,
        left: matrixInfo.left,
        mainRight: matrixInfo.mainRight,
        mainLeft: matrixInfo.mainLeft
    });
    var newIndexDay = getIndexDayOfCoordinateCursor(format, isEmptyOldStartPosition, cursorY, {
        cellHeight: matrixInfo.cellHeight,
        top: matrixInfo.top,
        mainBottom: matrixInfo.mainBottom,
        mainTop: matrixInfo.mainTop
    });
    var isOverCell = cursorX >= matrixInfo.left &&
        cursorX <= matrixInfo.mainRight &&
        cursorY >= matrixInfo.mainTop &&
        cursorY <= matrixInfo.mainBottom;
    return {
        newIndexHour: newIndexHour,
        newIndexDay: newIndexDay,
        isOverCell: isOverCell
    };
};
//# sourceMappingURL=lib-for-Matrix.js.map